import {
	SalesCollectDetailDto,
	SalesCollectHeaderDto,
	defaultSalesCollectDetailDto,
	defaultSalesCollectHeaderDto,
} from "src/dtos/salesCollect/salesCollectDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface SAL3010_R01Dto {
	salesCollectHeaderDto: SAL3010_R01HeaderDto;
	salesCollectDetailDtoList: SAL3010_R01DetailDto[];
}

export interface SAL3010_R01HeaderDto extends SalesCollectHeaderDto {
    bankAcctCd: string;	// 입금계좌코드
	tradeNo: string;
	tradeType: string;	// 수금구분 예외여부 Y/N
	tradeDt: string;
	tradeAmt: number;
}

export const defaultSAL3010_R01HeaderDto: SAL3010_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	collectNo: '',
	compCd: '',
	compNm: '',
	collectDt: formatDate(new Date()),
	customCd: '',
	customNm: '',
	collectType: '',
	empNo: '',
	empNm: '',
	moneyCd: '',
	moneyRate: 0,
	collectAmt: 0,
	cashAmt: 0,
	cardAmt: 0,
	cmsAmt: 0,
	bankbookAmt: 0,
	bankCd: '',
	bankAcctNo: '',
	noteAmt: 0,
	noteNo: '',
	noteCreateFlg: '',
	issueDt: formatDate(new Date()),
	dueDt: formatDate(new Date()),
	noteBankCd: '',
	publisher: '',
	endorseCnt: 0,
	dcAmt: 0,
	advancesRcp: 0,
	advancesRcpNo: '',
	approveFlg: '',
	exceptionFlg: "N",
	remark: '',

    bankAcctCd: '',
	tradeNo: '',
	tradeType: '',
	tradeDt: formatDate(new Date()),
	tradeAmt: 0,

	inserted: false,
	isModified: false,
}	


export interface SAL3010_R01DetailDto extends SalesCollectDetailDto {
	
    salBillNo: string;
    itemCd: string;
    itemNm: string;
    itemSpec: string;
    modelNo: string;
    unit: string;
    compCd: string;
    customCd: string;
    salesDt: string;
    itemSeq: number;
    salesQty: number;
    itemCost: number;
    salesPrice: number;
    dcAmt: number;
    itemAmt: number;
    checkProcess: string;
	tradeNo: string;

}

export const defaultSAL3010_R01DetailDto: SAL3010_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	itemNo: '',
	tradeDt: formatDate(new Date()),
	tradeType: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemPrice: 0,
	vatAmt: 0,
	billAmt: 0,
	collectAmt: 0,
	basOrderNo: '',
	basOrderItemNo: '',
	remark: '',

	salBillNo: '',
	modelNo: '',
	unit: '',
	compCd: '',
	customCd: '',
	salesDt: formatDate(new Date()),
	itemSeq: 0,
	salesQty: 0,
	itemCost: 0,
	salesPrice: 0,
	dcAmt: 0,
	itemAmt: 0,
	checkProcess: 'N',
	tradeNo: '',

	inserted: false,
	isModified: false,
}
